module.exports = "/_next/static/images/3153e8e01fcac92a24dd62479e86ead9-slide-3-large.png";